import React, { FC, ReactNode } from 'react'
import styles from 'styles/components/card.module.scss'

type Props = {
  children: ReactNode
}

const CardOutlined: FC<Props> = (props) => {
  const { children } = props
  return <section className={styles.outline}>{children}</section>
}

export default CardOutlined
